module.exports = __webpack_public_path__ + "img/logo.cee19414.png";